"use strict";
exports["4465435e"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizTeamsOutlookAddinTitle","description":"WizTeamsOutlookAddinDesc","properties":{"oAuthCredential":{"type":"object","title":"TeamsUserOAuthCredentialsLabel"},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["oAuthCredential","notice","proofOfWork"],"$id":"4465435e"};

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="4465435e" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.oAuthCredential === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "oAuthCredential"},message:"must have required property '"+"oAuthCredential"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.notice === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.proofOfWork === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.oAuthCredential !== undefined){
let data0 = data.oAuthCredential;
if(!(data0 && typeof data0 == "object" && !Array.isArray(data0))){
const err3 = {instancePath:instancePath+"/oAuthCredential",schemaPath:"#/properties/oAuthCredential/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.oAuthCredential.type,parentSchema:schema11.properties.oAuthCredential,data:data0};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.notice !== undefined){
let data1 = data.notice;
if(data1 && typeof data1 == "object" && !Array.isArray(data1)){
if(data1.testAccountConsent === undefined){
const err4 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data1};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data1.testAccountConsent !== undefined){
let data2 = data1.testAccountConsent;
if(typeof data2 !== "boolean"){
const err5 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data2};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data1};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data3 = data.proofOfWork;
if(typeof data3 !== "string"){
const err7 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data3};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}
